<div class="nav-header" [style.background-color]="backgroundColor">
	<img class="nav-logo" src="{{ url }}" />
</div>
